export default {
  brand: 'Corendon',
  brandTagline: 'Service Reception',
  heroTitle: 'Welcome to Corendon Service Reception',
  heroSubtitle: 'Talk to our digital assistant about your flight, rebooking, or confirmation.',
  startButton: 'Start conversation',
  endButton: 'End conversation',
  loading: 'Connecting…',
  micHint: 'Your browser will ask for microphone access once.',
  micPermissionTitle: 'Microphone access required',
  micPermissionBody: 'Please allow microphone access so you can speak with the assistant.',
  helpListTitle: 'We can help you with:',
  helpItem1: 'Flight status and delays',
  helpItem2: 'Changing or rebooking flights',
  helpItem3: 'Email confirmations',
  pausedTitle: 'Conversation paused',
  pausedBody: "Mobile browsers can't keep audio active in the background. Return to this tab to continue.",
  resumed: 'Welcome back — picking up where we left off.',
  installPwaIos: 'For the best experience: tap the share icon and choose "Add to Home Screen".',
  installPwaAndroid: 'Install Corendon as an app for the best experience.',
  installPwaButton: 'Install',
  installPwaDismiss: 'Not now',
  footerDemo: 'Demo environment — this service uses fictional booking data.',
  errorGeneric: 'Something went wrong. Please try again.',
  errorAuthRequired: 'You need to sign in to use the assistant.',
  loginButton: 'Sign in with Google',
}
